/* Sticky ATC /////////////////*/

document.addEventListener('DOMContentLoaded', function () {
  const sticky = document.getElementById('sticky-atc');
  const productForm = document.querySelector('form.product-page--form');

  if (!sticky || !productForm) return;

  // Real elements in main form (source of truth)
  const mainAtcBtn = productForm.querySelector('.product-buy-buttons--primary');
  const mainSizeRadios = productForm.querySelectorAll(
    '.radios--input[data-option-name="size"]'
  );

  // Fake elements in sticky bar
  const stickyAtcBtn = sticky.querySelector('.sticky-atc__button');
  const stickySizeBtns = sticky.querySelectorAll('.sticky-atc__size-btn');

  if (!mainAtcBtn || !mainSizeRadios.length || !stickyAtcBtn || !stickySizeBtns.length) return;

  const stickyAtcLabelEl =
    stickyAtcBtn.querySelector('.sticky-atc__button-text') || stickyAtcBtn;

  const defaultStickyLabel =
    stickyAtcBtn.getAttribute('data-text') ||
    stickyAtcLabelEl.textContent.trim() ||
    'Add to cart';

  const outOfStockLabel =
    stickyAtcBtn.getAttribute('data-out-of-stock-text') || 'Out of stock';

  // --- availability map from original size labels (by value) ---
  function buildAvailabilityMap() {
    const map = {};
    document.querySelectorAll('.radios--value-button').forEach((label) => {
      const input = label.querySelector(
        '.radios--input[data-option-name="size"]'
      );
      if (!input) return;
      const value = input.value;
      const unavailable = label.dataset.unavailable === 'true';
      map[value] = unavailable;
    });
    return map;
  }

  function getMainSelectedSize() {
    const checked = productForm.querySelector(
      '.radios--input[data-option-name="size"]:checked'
    );
    return checked ? checked.value : null;
  }

  // --- 1. sticky sizes: active + unavailable states ---

  function syncStickySizes() {
    const availabilityMap = buildAvailabilityMap();
    const current = getMainSelectedSize();

    stickySizeBtns.forEach((btn) => {
      const value = btn.dataset.sizeValue;

      // active
      const isActive = value === current;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');

      // unavailable
      const unavailable = !!availabilityMap[value];
      btn.classList.toggle('is-unavailable', unavailable);
      btn.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      // if you want to hard-disable click on sold-out sizes, uncomment:
      // btn.disabled = unavailable;
    });
  }

  // --- 2. sticky CTA state (enabled/disabled + label) ---

  function isCurrentVariantUnavailable() {
    const availabilityMap = buildAvailabilityMap();
    const currentSize = getMainSelectedSize();

    // From label map (most reliable)
    const bySize =
      currentSize && Object.prototype.hasOwnProperty.call(availabilityMap, currentSize)
        ? availabilityMap[currentSize]
        : false;

    // Extra safety: also look at main button
    const byDisabled = mainAtcBtn.disabled;
    const byText = /out of stock/i.test(mainAtcBtn.textContent);

    return !!(bySize || byDisabled || byText);
  }

  function updateStickyCtaState() {
    const unavailable = isCurrentVariantUnavailable();

    stickyAtcBtn.disabled = unavailable;
    stickyAtcBtn.setAttribute('aria-disabled', unavailable ? 'true' : 'false');

    if (unavailable) {
      stickyAtcLabelEl.textContent = outOfStockLabel;
    } else {
      stickyAtcLabelEl.textContent = defaultStickyLabel;
    }
  }

  // --- 3. sticky → main size change wiring ---

  function syncMainFromSticky(sizeValue) {
    const selector =
      '.radios--input[data-option-name="size"][value="' + sizeValue + '"]';
    const target = productForm.querySelector(selector);

    if (target && !target.disabled) {
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  stickySizeBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const value = btn.dataset.sizeValue;
      syncMainFromSticky(value);
      syncStickySizes();
      updateStickyCtaState();
    });
  });

  mainSizeRadios.forEach((radio) => {
    radio.addEventListener('change', () => {
      syncStickySizes();
      updateStickyCtaState();
    });
  });

  // Initial state on load
  syncStickySizes();
  updateStickyCtaState();

  // Watch the main ATC for changes (theme may toggle text/disabled)
  const atcObserver = new MutationObserver(updateStickyCtaState);
  atcObserver.observe(mainAtcBtn, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['disabled', 'aria-busy'],
  });

  // --- sticky CTA: delegate to main ---

  stickyAtcBtn.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (isCurrentVariantUnavailable()) return;

    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    stickyAtcBtn.setAttribute('aria-busy', 'true');

    mainAtcBtn.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );

    requestAnimationFrame(() => {
      window.scrollTo(scrollX, scrollY);
      stickyAtcBtn.setAttribute('aria-busy', 'false');
    });
  });

  // --- show/hide sticky based on scroll ---

  function handleScroll() {
    const rect = mainAtcBtn.getBoundingClientRect();
    const inView = rect.top < window.innerHeight && rect.bottom > 0;

    if (inView) {
      sticky.classList.remove('is-visible');
    } else {
      sticky.classList.add('is-visible');
    }
  }

  handleScroll();
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll);
});
